<template>
  <div>
    <v-form ref="form" autocomplete="off" @submit.prevent="noopSubmit">
        <v-row>
            <!-- Sección: Datos principales del cliente -->
            <v-col cols="12">
                <div class="text-subtitle-1 font-weight-medium grey--text text--darken-2 mb-3">
                    Datos del cliente
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <v-select prepend-icon="mdi-card-account-details" name="tipoDocumento" v-model="form.tipoDocumento"
                    :items="tiposDocumento" :label="$t('cliente.labels.tipoDocumento')"
                    :placeholder="$t('cliente.labels.tipoDocumento')" :error="hasInputErrors('tipoDocumento')"
                    :error-messages="getInputErrors('tipoDocumento')" color="secondary" :rules="required"></v-select>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field prepend-icon="mdi-identifier" name="numeroDocumento"
                    :value="form.numeroDocumento"
                    @input="onNumeroDocumentoInput"
                    :maxlength="numeroDocumentoMaxLength"
                    :label="$t('cliente.labels.numeroDocumento')" :placeholder="numeroDocumentoPlaceholder"
                    :error="hasInputErrors('numeroDocumento')" :error-messages="getInputErrors('numeroDocumento')"
                    color="secondary" :rules="documentoRules"></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" class="d-flex align-center">
                <v-btn v-if="afipActivo && form.tipoDocumento === 'CUIT'" color="primary" @click="consultarDatosArca"
                    :loading="consultandoArca" :disabled="!puedeConsultarArca" block>
                    <v-icon left small>mdi-cloud-search</v-icon>
                    Buscar en AFIP
                </v-btn>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field prepend-icon="mdi-office-building" name="razonSocial" v-model="form.razonSocial"
                    :label="form.tipoDocumento === 'DNI' ? $t('cliente.labels.nombrePersona') : $t('cliente.labels.razonSocial')"
                    :placeholder="form.tipoDocumento === 'DNI' ? $t('cliente.labels.nombrePersona') : $t('cliente.labels.razonSocial')"
                    :error="hasInputErrors('razonSocial')" :error-messages="getInputErrors('razonSocial')"
                    color="secondary" :rules="required"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-select prepend-icon="mdi-receipt" name="condicionIVA" v-model="form.condicionIVA"
                    :items="condicionesIVA" item-text="text" item-value="value"
                    :label="$t('cliente.labels.condicionIVA')"
                    :placeholder="$t('cliente.labels.condicionIVA')" :error="hasInputErrors('condicionIVA')"
                    :error-messages="getInputErrors('condicionIVA')" color="secondary" :rules="required"
                    :disabled="condicionIVADisabled"></v-select>
            </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <v-row>
            <!-- Sección: Contacto y estado -->
            <v-col cols="12">
                <div class="text-subtitle-1 font-weight-medium grey--text text--darken-2 mb-3">
                    Contacto y estado
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field prepend-icon="mdi-email" name="email" v-model="form.email" type="email"
                    :label="$t('cliente.labels.email')" :placeholder="$t('cliente.labels.email')"
                    :error="hasInputErrors('email')" :error-messages="getInputErrors('email')"
                    color="secondary"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field prepend-icon="mdi-phone" name="telefono" v-model="form.telefono"
                    :label="$t('cliente.labels.telefono')" :placeholder="$t('cliente.labels.telefono')"
                    :error="hasInputErrors('telefono')" :error-messages="getInputErrors('telefono')"
                    color="secondary"></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-text-field prepend-icon="mdi-map-marker" name="domicilio" v-model="form.domicilio"
                    :label="$t('cliente.labels.domicilio')" :placeholder="$t('cliente.labels.domicilio')"
                    :error="hasInputErrors('domicilio')" :error-messages="getInputErrors('domicilio')"
                    color="secondary"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field prepend-icon="mdi-home-city" name="piso" v-model="form.piso"
                    :label="$t('cliente.labels.piso')" :placeholder="$t('cliente.labels.piso')"
                    :error="hasInputErrors('piso')" :error-messages="getInputErrors('piso')"
                    color="secondary"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field prepend-icon="mdi-door" name="departamento" v-model="form.departamento"
                    :label="$t('cliente.labels.departamento')" :placeholder="$t('cliente.labels.departamento')"
                    :error="hasInputErrors('departamento')" :error-messages="getInputErrors('departamento')"
                    color="secondary"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field prepend-icon="mdi-mailbox" name="codigoPostal" v-model="form.codigoPostal"
                    :label="$t('cliente.labels.codigoPostal')" :placeholder="$t('cliente.labels.codigoPostal')"
                    :error="hasInputErrors('codigoPostal')" :error-messages="getInputErrors('codigoPostal')"
                    color="secondary"></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-switch v-model="form.activo" :label="$t('cliente.labels.activo')" color="secondary"></v-switch>
            </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <v-row>
            <v-col cols="12">
                <div class="text-subtitle-1 font-weight-medium grey--text text--darken-2 mb-3">
                    Preferencias comerciales
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <v-select
                    prepend-icon="mdi-format-list-numbered"
                    name="listaPreciosVentaDefaultId"
                    v-model="form.listaPreciosVentaDefaultId"
                    :items="listasPrecios"
                    item-text="nombre"
                    item-value="id"
                    :label="$t('cliente.labels.listaPreciosVentaDefault') || 'Lista de precios por defecto'"
                    placeholder="Default global"
                    color="secondary"
                    clearable
                />
            </v-col>
            <v-col cols="12" sm="6">
                <v-select
                    prepend-icon="mdi-file-document-outline"
                    name="tipoComprobanteDefault"
                    v-model="form.tipoComprobanteDefault"
                    :items="tiposComprobanteDefault"
                    item-text="text"
                    item-value="value"
                    label="Tipo de comprobante (facturación masiva)"
                    placeholder="Seleccionar tipo"
                    color="secondary"
                    clearable
                    hint="Requerido para facturación masiva automática"
                    persistent-hint
                />
            </v-col>
        </v-row>

        <snackbar v-model="snackbarMessage" :color="snackbarColor" />
    </v-form>

    <v-dialog v-model="docVentaReminderOpen" max-width="520" persistent>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon left color="amber darken-2">mdi-file-document-alert-outline</v-icon>
          {{ $t('cliente.documentosVentaReminderTitle') }}
        </v-card-title>
        <v-card-text class="pt-2">
          {{ $t('cliente.documentosVentaReminderText') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelDocVentaReminder">
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn color="primary" @click="confirmDocVentaReminder">
            {{ $t('common.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { InputErrorsByProps, RequiredRule, Snackbar } from '@dracul/common-frontend'
import ClienteProvider from '../../../providers/ClienteProvider'
import CompanyProvider from '../../../../base/providers/CompanyProvider'
import ListaPreciosVentaProvider from '../../../../lista-precios-venta/providers/ListaPreciosVentaProvider'
import { applyCuitCuilInput, formatCuitCuilDisplay } from '../../../../../utils/cuitCuilFormat'

/** Fuera del componente: los computed no deben depender de `this` para helpers (orden de init en Vue 2). */
function condicionesIVAItemsPorTipoDocumento(tipoDocumento) {
    const consumidorFinal = { text: 'Consumidor Final', value: 'CONSUMIDOR_FINAL' }
    // DNI y CUIL: solo Consumidor Final. CUIT: CF o condiciones con clave fiscal.
    if (tipoDocumento === 'DNI' || tipoDocumento === 'CUIL') return [consumidorFinal]
    if (tipoDocumento === 'CUIT') {
        return [
            consumidorFinal,
            { text: 'Responsable Inscripto', value: 'RESPONSABLE_INSCRIPTO' },
            { text: 'Monotributista', value: 'MONOTRIBUTISTA' },
            { text: 'Exento (IVA)', value: 'EXENTO' },
            { text: 'No responsable / Sujeto no categorizado', value: 'SUJETO_NO_CATEGORIZADO' }
        ]
    }
    return [
        { text: 'Responsable Inscripto', value: 'RESPONSABLE_INSCRIPTO' },
        consumidorFinal
    ]
}

export default {
    name: "ClienteForm",
    components: { Snackbar },
    mixins: [InputErrorsByProps, RequiredRule],

    props: {
        value: {
            type: Object,
            required: true
        },
        confirmDocumentosVentaReminder: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            afipActivo: false,
            consultandoArca: false,
            estadoClaveAfip: null,
            snackbarMessage: null,
            snackbarColor: 'success',
            docVentaReminderOpen: false,
            pendingSubmit: null,
            listasPrecios: [],
        }
    },
    computed: {
        form: {
            get() { return this.value },
            set(val) { this.$emit('input', val) }
        },
        tiposDocumento() {
            return [
                { text: 'CUIT', value: 'CUIT' },
                { text: 'CUIL', value: 'CUIL' },
                { text: 'DNI', value: 'DNI' },
            ]
        },
        condicionesIVA() {
            return condicionesIVAItemsPorTipoDocumento(this.form.tipoDocumento)
        },
        condicionIVADisabled() {
            return this.form.tipoDocumento === 'DNI' || this.form.tipoDocumento === 'CUIL'
        },
        tiposComprobanteDefault() {
            return [
                { text: 'Factura A', value: 'FACTURA_A' },
                { text: 'Factura B', value: 'FACTURA_B' },
                { text: 'Factura C', value: 'FACTURA_C' },
                { text: 'Factura X (no fiscal)', value: 'FACTURA_X' },
            ]
        },
        documentoRules() {
            return [
                (v) => {
                    if (v === null || v === undefined || String(v).trim() === '') return true
                    return this.validarFormatoDocumento(String(v).trim()) || this.$t('cliente.messages.documentoInvalido')
                },
            ]
        },
        numeroDocumentoPlaceholder() {
            if (this.form.tipoDocumento === 'CUIT' || this.form.tipoDocumento === 'CUIL') {
                return '30-71513211-3'
            }
            return this.$t('cliente.labels.numeroDocumento')
        },
        esDocumentoCuitCuil() {
            return this.form.tipoDocumento === 'CUIT' || this.form.tipoDocumento === 'CUIL'
        },
        numeroDocumentoMaxLength() {
            return this.esDocumentoCuitCuil ? 13 : 8
        },
        puedeConsultarArca() {
            return !!this.form.numeroDocumento && this.validarFormatoDocumento(this.form.numeroDocumento)
        },
    },
    async created() {
        await this.cargarAfipActivo()
        if (this.esDocumentoCuitCuil && this.form.numeroDocumento) {
            this.form.numeroDocumento = formatCuitCuilDisplay(this.form.numeroDocumento)
        }
        this.cargarListasPrecios()
    },
    watch: {
        form: {
            handler(newVal) {
                this.$emit('input', newVal)
            },
            deep: true
        },
        'form.tipoDocumento'(newVal) {
            const items = condicionesIVAItemsPorTipoDocumento(newVal)
            const allowed = new Set(items.map((i) => i.value))
            if (allowed.has(this.form.condicionIVA)) return
            if (newVal === 'DNI' || newVal === 'CUIL') {
                this.form.condicionIVA = 'CONSUMIDOR_FINAL'
            } else if (newVal === 'CUIT') {
                this.form.condicionIVA = 'RESPONSABLE_INSCRIPTO'
            }
            if ((newVal === 'CUIT' || newVal === 'CUIL') && this.form.numeroDocumento) {
                this.form.numeroDocumento = formatCuitCuilDisplay(this.form.numeroDocumento)
            } else if (newVal === 'DNI' && this.form.numeroDocumento) {
                this.form.numeroDocumento = String(this.form.numeroDocumento).replace(/\D/g, '').slice(0, 8)
            }
        }
    },
    methods: {
        async cargarListasPrecios() {
            try {
                const r = await ListaPreciosVentaProvider.list()
                this.listasPrecios = (r && r.data && r.data.listaPreciosVentaList) || []
            } catch (e) {
                this.listasPrecios = []
            }
        },
        async cargarAfipActivo() {
            try {
                const response = await CompanyProvider.companyAfipStatus()
                const st = response.data && response.data.companyAfipStatus
                this.afipActivo = !!(st && st.afipActivo)
            } catch (e) {
                this.afipActivo = false
            }
        },
        onNumeroDocumentoInput(val) {
            if (this.esDocumentoCuitCuil) {
                this.form.numeroDocumento = applyCuitCuilInput(val)
            } else {
                this.form.numeroDocumento = String(val || '').slice(0, 8)
            }
        },
        noopSubmit() {},
        validate() {
            return this.$refs.form.validate()
        },
        validateThenConfirm(onProceed) {
            if (typeof onProceed !== 'function') return
            if (!this.$refs.form.validate()) return
            if (!this.confirmDocumentosVentaReminder) {
                onProceed()
                return
            }
            this.pendingSubmit = onProceed
            this.docVentaReminderOpen = true
        },
        cancelDocVentaReminder() {
            this.docVentaReminderOpen = false
            this.pendingSubmit = null
        },
        confirmDocVentaReminder() {
            const fn = this.pendingSubmit
            this.docVentaReminderOpen = false
            this.pendingSubmit = null
            if (fn) fn()
        },
        validarFormatoDocumento(documento) {
            if (!documento) return true
            if (this.form.tipoDocumento === 'CUIT' || this.form.tipoDocumento === 'CUIL') {
                return /^\d{11}$/.test(documento.replace(/[-]/g, ''))
            }
            if (this.form.tipoDocumento === 'DNI') {
                return /^\d{7,8}$/.test(documento)
            }
            return true
        },
        async consultarDatosArca() {
            if (!this.puedeConsultarArca) {
                this.snackbarColor = 'error'
                this.snackbarMessage = this.$t('cliente.messages.ingreseNumeroDocumento') || 'Por favor ingrese el número de documento'
                return
            }

            this.consultandoArca = true
            this.estadoClaveAfip = null

            try {
                const cuitConsulta = String(this.form.numeroDocumento || '').replace(/\D/g, '')
                const response = await ClienteProvider.consultarArca(cuitConsulta)

                // Verificar que la respuesta tenga la estructura esperada
                if (!response || !response.data || !response.data.clienteConsultarArca) {
                    throw new Error('Respuesta inválida del servidor')
                }

                const data = response.data.clienteConsultarArca

                if (data.success && data.persona && data.persona.datosGenerales) {
                    const { persona } = data
                    const dg = persona.datosGenerales

                    // Razón Social
                    if (dg.razonSocial) this.form.razonSocial = dg.razonSocial

                    // Domicilio fiscal
                    const domFiscal = dg.domicilioFiscal
                    if (domFiscal) {
                        if (domFiscal.direccion) this.form.domicilio = domFiscal.direccion
                        if (domFiscal.codPostal) this.form.codigoPostal = String(domFiscal.codPostal)
                    }

                    // Condición IVA inferida desde impuestos AFIP
                    const impuestos = persona.datosRegimenGeneral?.impuesto || []
                    const tieneMonotributo = !!persona.datosMonotributo?.categoria
                    const ivaActivo = impuestos.find(i => i.idImpuesto === 30 && i.estadoImpuesto === 'AC')
                    const ivaExento = impuestos.find(i => i.idImpuesto === 30 && i.estadoImpuesto === 'EX')
                    if (tieneMonotributo) {
                        this.form.condicionIVA = 'MONOTRIBUTISTA'
                    } else if (ivaActivo) {
                        this.form.condicionIVA = 'RESPONSABLE_INSCRIPTO'
                    } else if (ivaExento) {
                        this.form.condicionIVA = 'EXENTO'
                    } else {
                        this.form.condicionIVA = 'CONSUMIDOR_FINAL'
                    }

                    // Mostrar estado del contribuyente
                    const estadoFinal = dg.estadoClave || persona.estadoClave
                    if (estadoFinal) {
                        this.estadoClaveAfip = estadoFinal

                        if (estadoFinal === 'ACTIVO') {
                            this.snackbarColor = 'success'
                            this.snackbarMessage = `Cliente encontrado en AFIP - Estado: ${estadoFinal}`
                        } else {
                            this.snackbarColor = 'warning'
                            this.snackbarMessage = `Cliente encontrado en AFIP - Estado: ${estadoFinal}`
                        }
                    } else {
                        this.snackbarColor = 'success'
                        this.snackbarMessage = 'Datos obtenidos de AFIP correctamente'
                    }
                } else {
                    this.snackbarColor = 'error'
                    this.snackbarMessage = 'No se encontraron datos del contribuyente en AFIP'
                }
             } catch (error) {
                 console.error('Error consultando ARCA:', error)
                 this.snackbarColor = 'error'
                 
                 // Mostrar mensaje amigable según el tipo de error
                 if (error.message && error.message.includes('Network')) {
                     this.snackbarMessage = 'Error de conexión. Verifique su conexión a internet e intente nuevamente.'
                 } else if (error.message && error.message.includes('timeout')) {
                     this.snackbarMessage = 'La consulta a AFIP tardó demasiado. Por favor intente nuevamente.'
                 } else {
                     this.snackbarMessage = 'Error al consultar datos de AFIP. Por favor intente nuevamente.'
                 }
             } finally {
                 this.consultandoArca = false
             }
        }
    }
}
</script>

<style scoped></style>
